
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { ReactNode } from "react";
import { useLocation } from "react-router-dom";

type Props = {
  href: string;
  children: ReactNode;
  active?: boolean;
  className?: string;
  target?: "_blank";
};

export function NavBarItem({
  children,
  href,
  active,
  target,
  className,
}: Props) {
  const { pathname } = useLocation();
  
  // Handle link click with immediate scroll reset
  const handleClick = (event: React.MouseEvent) => {
    // Skip for external links
    if (target === '_blank' || href.startsWith('http')) {
      return;
    }
    
    // For same page links, let them work normally
    if (pathname === href) {
      return;
    }
    
    // For navigation to different pages, force an immediate scroll reset
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  // Use direct browser navigation for internal links
  return (
    <a
      href={href}
      className={cn(
        "flex items-center justify-center text-sm leading-[110%] px-4 py-2 rounded-md hover:bg-[#F5F5F5] dark:hover:bg-neutral-800 hover:text-black text-muted dark:text-muted-dark",
        (active || pathname?.includes(href)) &&
          "bg-gray-100 dark:bg-neutral-800 text-black",
        className
      )}
      target={target}
    >
      {children}
    </a>
  );
}
